import React from 'react'
import { Form } from 'react-bootstrap'
import FormProductGeneralInfo from './FormProductGeneralInfo'
import ProductImagegesAndVideo from './ProductImagegesAndVideo'
import ProductDocuments from './ProductDocuments'
import '../../../../assests/styles/backoffice/uploadFileStyle.scss'

const ProductsFormGeneral = ({
  inputs,
  handleSubmit,
  handleChange,
  isDisable,
  categories,
  select,
  allTypesOfDocuments,
  uploadCoverImage,
  uploadImages,
  uploadDocs,
  textBtn,
}) => {
  return (
    <div className='task__container'>
      <Form onSubmit={handleSubmit}>
        <h2 className='mb-30 products__title'>Información general</h2>

        <FormProductGeneralInfo
          inputs={inputs}
          handleChange={handleChange}
          categories={categories}
          select={select}
          newProduct={true}
        />
        {inputs.isArticuloFinal ? (
          <>
            <h2 className='mb-10 mt-80 products__subtitle'>Imágenes y vídeo</h2>
            <ProductImagegesAndVideo
              inputs={inputs}
              uploadCoverImage={uploadCoverImage}
              uploadImages={uploadImages}
              handleChange={handleChange}
            />
          </>
        ) : null}
        <h2 className='mb-10 mt-80 products__title'>Documentos</h2>
        <ProductDocuments
          allTypesOfDocuments={allTypesOfDocuments}
          uploadDocs={uploadDocs}
        />
        <button className='btn' onClick={handleSubmit} disabled={isDisable}>
          {textBtn}
        </button>
      </Form>
    </div>
  )
}

export default ProductsFormGeneral
